var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector109(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3947 9.40491L9.89472 11.9049C12.2091 16.7758 14.3431 18.9991 19.8947 21.9049L22.3945 19.405C23.3945 18.405 24.3945 18.405 25.3945 19.405L29.3945 23.405L29.3946 23.4051C30.0696 24.4177 30.3945 24.905 29.3945 26.405L26.3947 29.405C18.3948 35.405 -4.10546 11.9049 2.89472 4.90491L5.39471 2.40491C6.29211 1.57473 7.39472 1.40496 7.89472 1.90491L12.3947 6.40491C13.3947 7.40491 13.3947 8.40491 12.3947 9.40491Z",
    stroke: "#709FDC",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector109);
export default __webpack_public_path__ + "static/media/Vector109.a82aa567faaa904c0c4d54a44b90f886.svg";
export { ForwardRef as ReactComponent };